// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Admin-___admin__container___2jG-D","nav":"src-components-Admin-___admin__nav___3tWs3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/admin.css
// module id = 1045
// module chunks = 0